import { BrowserRouter as Router } from "react-router-dom";
import './App.css'
import { DataProvider } from './context/data'
import {HeroUIProvider, ToastProvider} from "@heroui/react";
import { Suspense } from 'react';
import AppRoutes from './routes/index';
import { ToastProvider as LocalToast } from "./context/toast";
import { AuthProvider } from "./context/auth";
import Loader from './components/loader';
import moment from 'moment';
import 'moment/locale/fr';
import { Chart, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from 'chart.js';
import { SocketProvider } from "./context/socket";

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);


moment.locale('fr');

if ("Notification" in window && "serviceWorker" in navigator) {

  Notification.requestPermission().then(permission => {
    if (permission === "granted") {
      console.log("✅ Notifications activées !");
    }
  });

}

if ("Notification" in window && "serviceWorker" in navigator) {

  navigator.serviceWorker.register(`/sw.js`)
    .then(reg => console.log("✅ Service Worker enregistré", reg))
    .catch(err => console.error("❌ Erreur SW", err));
    
}


if ("Notification" in window && "serviceWorker" in navigator) {

  navigator.serviceWorker.addEventListener("message", event => {
    if (event.data.type === "play-sound") {
      const audio = new Audio("/bell.mp3"); // 🔔 
      audio.play().catch(err => console.log("🔇 Erreur audio :", err));
    }
  });
  
}

function App() {
  
  return (
    <HeroUIProvider>
      <DataProvider>
        <LocalToast>
          <ToastProvider/>
          <SocketProvider>
            <Router>
              <AuthProvider>
                <Suspense fallback={<Loader/>}>
                  <AppRoutes/>
                </Suspense>
              </AuthProvider>
            </Router>
          </SocketProvider>
        </LocalToast>
      </DataProvider>
    </HeroUIProvider>
  )
}

export default App
